module.exports = __webpack_public_path__ + "media/images/emblems/Steinmaur-blazon-c0217ab8d26afbe6c066f05407773599.svg";